import React from 'react';

const Contact = () => {
    return (
        <div className="container mx-auto px-6 py-12">
            <h1 className="text-4xl font-bold mb-6 text-gray-800">Contact Us</h1>
            <p className="text-lg text-gray-600 mb-8">
                We would love to hear from you. Please reach out to us using the contact information below.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-white p-6 rounded-lg shadow-md">
                    <h2 className="text-2xl font-semibold mb-4 text-gray-800">Get in Touch</h2>
                    <form className="space-y-4">
                        <div>
                            <label className="block text-gray-700 mb-2">Name</label>
                            <input type="text" className="w-full border border-gray-300 rounded-md px-4 py-2" placeholder="Your Name" />
                        </div>
                        <div>
                            <label className="block text-gray-700 mb-2">Email</label>
                            <input type="email" className="w-full border border-gray-300 rounded-md px-4 py-2" placeholder="your@email.com" />
                        </div>
                        <div>
                            <label className="block text-gray-700 mb-2">Message</label>
                            <textarea className="w-full border border-gray-300 rounded-md px-4 py-2" rows="4" placeholder="How can we help?"></textarea>
                        </div>
                        <button type="button" className="bg-green-600 text-white px-6 py-2 rounded-md hover:bg-green-700 transition-colors">
                            Send Message
                        </button>
                    </form>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-md">
                    <h2 className="text-2xl font-semibold mb-4 text-gray-800">Contact Info</h2>
                    <div className="space-y-4 text-gray-600">
                        <p><strong>Email:</strong> support@taxberg.com</p>
                        <p><strong>Phone:</strong> +91 123 456 7890</p>
                        <p><strong>Address:</strong> 123 Tax Street, Finance City, India</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
